import {afterNextRender, Component, DestroyRef, ElementRef, inject, viewChild} from '@angular/core';
import {SchemeFacade} from '../application/scheme.facade';
import {SchemeCard} from '../ui/scheme-card/scheme-card';
import {SearchFacade} from '../../search/application/search.facade';
import {MatGridList, MatGridTile} from '@angular/material/grid-list';

@Component({
  selector: 'app-scheme-page',
  imports: [
    SchemeCard,
    MatGridList,
    MatGridTile
  ],
  templateUrl: './scheme-page.html',
  styleUrl: './scheme-page.scss',
})
export class SchemePage {
  private readonly _schemeFacade = inject(SchemeFacade);
  private readonly _searchFacade = inject(SearchFacade);
  private readonly _destroyRef = inject(DestroyRef);

  private readonly _sentinel = viewChild.required<ElementRef<HTMLElement>>('sentinel');

  protected readonly scheme = this._schemeFacade.scheme;
  protected readonly schemes = this._searchFacade.schemes;

  constructor() {
    afterNextRender(() => {
      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            this._searchFacade.searchNext();
          }
        },
        { threshold: 0 }
      );
      observer.observe(this._sentinel().nativeElement);
      this._destroyRef.onDestroy(() => observer.disconnect());
    });
  }
}
